export default {
  en: {
    rule: 'Rules',
    reward: 'Reward',
    cd: 'CountDown',
    ruby_gift: 'RUBY GIFT',
    lw: 'LAST WEEK',
    tw: 'THIS WEEK',
    sender: 'Sender',
    recipient: 'Recipient',
    empty: 'No one on the leaderboard',
    days: 'Days',
    ruleContent: `
    1. Ruby Gift: Users who send or receive the rare item will receive a point in the corresponding list based on the price of the gift.
    <br/><br/>
    2. Weekly List: A list of senders and recipients is generated every week based on the points accumulated by users.
    <br/><br/>
    3. Ranking Rewards: At the end of each week, the top three from each list are rewarded.
    <br/><br/>
    4. Medals received: Users who achieve the same ranking for five consecutive weeks receive the medal permanently. If you stop, the continuous acquisition time is recalculated.
    <br/><br/>
    5. Right to official interpretation: The administrator reserves the final interpretation of this activity. If you have any questions, please contact our customer service staff and they will answer your questions.
    `
  },
  ar: {
    rule: 'القواعد',
    reward: 'مكافأة',
    cd: 'CountDown',
    ruby_gift: 'هدية روبي',
    lw: 'الأسبوع الماضي',
    tw: 'هذا الأسبوع',
    sender: 'المرسل',
    recipient: 'المستلم',
    empty: 'لا أحد على قائمة الصدارة',
    days: 'أيام',
    ruleContent: `
    1. هدية روبي: سيحصل المستخدمون الذين يرسلون أو يتلقون القطعة النادرة على نقطة في القائمة المقابلة بناءً على سعر الهدية. 
<br/><br/>
2. القائمة الأسبوعية: يتم إنشاء قائمة من المرسلين والمستلمين كل أسبوع بناءً على النقاط التي تراكمت من قبل المستخدمين. 
<br/><br/>
3. مكافآت الترتيب: في نهاية كل أسبوع ، يتم مكافأة الثلاثة الأوائل من كل قائمة. 
<br/><br/>
4. الميداليات التي تلقاها: المستخدمين الذين يحققون نفس الترتيب لمدة خمسة أسابيع متتالية يحصلون على الميدالية بشكل دائم. إذا توقفت ، يتم إعادة حساب وقت الاقتناء المستمر. 
<br/><br/>
5. الحق في التفسير الرسمي: يحتفظ المسؤول بالتفسير النهائي لهذا النشاط. إذا كان لديك أي أسئلة، يرجى الاتصال بموظفي خدمة العملاء وسوف يجيبون على أسئلتك. 
<br/><br/>
    `
  },
  tr: {
    rule: 'Kural',
    reward: 'Ödül',
    cd: 'CountDown',
    ruby_gift: 'Yakut hediye',
    lw: 'Geçen Hafta',
    tw: 'Bu Hafta',
    sender: 'Gönderen',
    recipient: 'Alıcı',
    empty: 'Liderlik tablosu',
    days: 'Gün',
    ruleContent: `
    1.  Yakut hediye:
    Yakut hediyeler gönderen veya alan kullanıcılar, hediye fiyatına göre ilgili listede bir puan kazanacaktır.
    <br/><br/>
    2.  Haftalık liste:
    Gönderen ve alıcıların listesi, kullanıcılar tarafından birikmiş puanlara göre her hafta oluşturulur.
    <br/><br/>
    3. Sıralama Ödülleri:
    Her haftanın sıralamasının sonunda, her listedeki ilk üç kişi ödüllendirilir.
    <br/><br/>
    4.  Alınan Madalyalar:
    Beş hafta üste aynı sıralamaya ulaşan kullanıcılar kalıcı olarak madalya alır. Ara verilirse, kalıcılık süresi yeniden hesaplanır.
    <br/><br/>
    5.  Resmi yorum hakkı:
    Bu faaliyetin nihai yorumu yetkiliye aittir. Sorularınız varsa, Lütfen müşteri hizmetleri ile iletişime geçin  ve sorularınızı cevaplayacaklar.
    <br/><br/>
    `
  },
  pt: {
    rule: 'Regras',
    reward: 'Recompensa',
    cd: 'Contagem Regressiva',
    ruby_gift: 'PRESENTE RUBI',
    lw: 'ÚLTIMA SEMANA',
    tw: 'ESTA SEMANA',
    sender: 'Remetente',
    recipient: 'Destinatário',
    empty: 'Nenhum na tabela de classificação',
    days: 'Dias',
    ruleContent:
      '1. Presente Rubi: Usuários que enviam ou recebem o item raro receberão um ponto na lista correspondente com base no preço do presente. <br/><br/> 2. Lista Semanal: Uma lista de remetentes e destinatários é gerada toda semana com base nos pontos acumulados pelos usuários. <br/><br/> 3. Recompensas de Classificação: No final de cada semana, os três primeiros de cada lista são recompensados. <br/><br/> 4. Medalhas recebidas: Usuários que atingem a mesma classificação por cinco semanas consecutivas recebem a medalha permanentemente. Se você parar, o tempo de aquisição contínuo será recalculado. <br/><br/> 5. Direito de interpretação oficial: O administrador reserva-se o direito final de interpretar esta atividade. Se você tiver alguma dúvida, entre em contato com nosso serviço de atendimento ao cliente e eles responderão às suas perguntas.'
  },
  id: {
    rule: 'Aturan',
    reward: 'Hadiah',
    cd: 'Hitung Mundur',
    ruby_gift: 'HADIAH RUBI',
    lw: 'MINGGU LALU',
    tw: 'MINGGU INI',
    sender: 'Pengirim',
    recipient: 'Penerima',
    empty: 'Tidak ada yang ada di papan peringkat',
    days: 'Hari',
    ruleContent:
      '1. Hadiah Rubi: Pengguna yang mengirim atau menerima item langka akan menerima satu poin dalam daftar yang sesuai berdasarkan harga hadiah. <br/><br/> 2. Daftar Mingguan: Daftar pengirim dan penerima dihasilkan setiap minggu berdasarkan poin yang dikumpulkan oleh pengguna. <br/><br/> 3. Hadiah Peringkat: Pada akhir setiap minggu, tiga teratas dari setiap daftar akan menerima hadiah. <br/><br/> 4. Medali yang diterima: Pengguna yang mencapai peringkat yang sama selama lima minggu berturut-turut akan menerima medali secara permanen. Jika Anda berhenti, waktu perolehan berkelanjutan akan dihitung ulang. <br/><br/> 5. Hak interpretasi resmi: Administrator berhak untuk memberikan interpretasi akhir atas aktivitas ini. Jika Anda memiliki pertanyaan, silakan hubungi staf layanan pelanggan kami dan mereka akan menjawab pertanyaan Anda.'
  },
  uz: {
    rule: 'Qoidalar',
    reward: 'Mukofot',
    cd: 'Hisoblash',
    ruby_gift: 'RUBIN HADYA',
    lw: 'OXIRGI HAFTA',
    tw: 'BU HAFTA',
    sender: 'Yuboruvchi',
    recipient: 'Qabul qiluvchi',
    empty: "Reytingda hech kim yo'q",
    days: 'Kunlar',
    ruleContent:
      "1. Rubin Hadya: Nadir buyumlarni yuborgan yoki qabul qilgan foydalanuvchilar, hadyaning narxiga asoslangan holda mos ro'yxatda bir ball olishadi. <br/><br/> 2. Haftalik Ro'yxat: Har hafta foydalanuvchilar tomonidan yig'ilgan ballarga asoslangan holda yuboruvchilar va qabul qiluvchilardan ro'yxat yaratiladi. <br/><br/> 3. Reyting Mukofotlari: Har hafta oxirida har bir ro'yxatdagi uchta eng yuqori o'rinda bo'lganlarga mukofot beriladi. <br/><br/> 4. Olingan Medallar: To'qqiz hafta davomida bir xil reytingga erishgan foydalanuvchilar medalni doimiy ravishda oladilar. Agar to'xtasangiz, davomiy vaqt qayta hisoblanadi. <br/><br/> 5. Rasmiy Talqin Huquqi: Administrator ushbu faoliyatning yakuniy talqinini saqlab qoladi. Agar biron bir savolingiz bo'lsa, iltimos, mijozlarga xizmat ko'rsatish xodimlarimiz bilan bog'laning va ular savollaringizga javob berishadi."
  },
  ru: {
    rule: 'Правила',
    reward: 'Награда',
    cd: 'Обратный отсчет',
    ruby_gift: 'ПОДАРОК РУБИН',
    lw: 'ПОСЛЕДНЯЯ НЕДЕЛЯ',
    tw: 'ЭТА НЕДЕЛЯ',
    sender: 'Отправитель',
    recipient: 'Получатель',
    empty: 'Нет записей в таблице лидеров',
    days: 'Дни',
    ruleContent:
      '1. Подарок Рубин: Пользователи, которые отправляют или получают редкие предметы, получают балл в соответствующем списке в зависимости от цены подарка. <br/><br/> 2. Еженедельный список: Список отправителей и получателей формируется каждую неделю на основе набранных пользователями баллов. <br/><br/> 3. Награды по результатам рейтинга: В конце каждой недели три лучших участника из каждого списка получают награды. <br/><br/> 4. Полученные медали: Пользователи, которые занимают одно и то же место в течение пяти недель подряд, получают медаль навсегда. Если вы остановитесь, время непрерывного получения будет пересчитано. <br/><br/> 5. Право на официальную интерпретацию: Администратор оставляет за собой право окончательной интерпретации этой активности. Если у вас есть вопросы, пожалуйста, свяжитесь с нашей службой поддержки, и они ответят на ваши вопросы.'
  },
  fa: {
    rule: 'قوانین',
    reward: 'پاداش',
    cd: 'شمارش معکوس',
    ruby_gift: 'هدیه RUBY',
    lw: 'هفته گذشته',
    tw: 'این هفته',
    sender: 'فرستنده',
    recipient: 'گیرنده',
    empty: 'هیچ کسی در لیست رتبه بندی نیست',
    days: 'روزها',
    ruleContent:
      '1. هدیه روبی: کاربران که اقلام نادر را ارسال یا دریافت می‌کنند، بر اساس قیمت هدیه، یک امتیاز در لیست مربوطه دریافت می‌کنند. <br/><br/> 2. لیست هفتگی: هر هفته فهرستی از فرستندگان و گیرندگان بر اساس امتیازاتی که کاربران جمع‌آوری کرده‌اند، ایجاد می‌شود. <br/><br/> 3. جوایز رتبه‌بندی: در پایان هر هفته، سه نفر اول از هر لیست جوایز دریافت می‌کنند. <br/><br/> 4. مدال‌های دریافت شده: کاربرانی که در پنج هفته متوالی رتبه یکسانی دارند، مدال را به طور دائم دریافت می‌کنند. اگر متوقف شوید، زمان به دست آوردن متوالی محاسبه مجدد می‌شود. <br/><br/> 5. حق تفسیر رسمی: مدیر، حق تفسیر نهایی این فعالیت را دارد. اگر سوالی دارید، لطفاً با پشتیبانی مشتریان ما تماس بگیرید و آن‌ها به سوالات شما پاسخ خواهند داد.'
  },
  ur: {
    rule: 'قواعد',
    reward: 'انعام',
    cd: 'الٹی گنتی',
    ruby_gift: 'روبی تحفہ',
    lw: 'پچھلا ہفتہ',
    tw: 'اس ہفتہ',
    sender: 'بھیجنے والا',
    recipient: 'وصول کنندہ',
    empty: 'درجہ بندی میں کوئی نہیں',
    days: 'دن',
    ruleContent: `
      1. روبی تحفہ: وہ صارفین جو نایاب آئٹم بھیجتے یا وصول کرتے ہیں، تحفہ کی قیمت کے مطابق متعلقہ فہرست میں ایک پوائنٹ حاصل کریں گے۔
      <br/><br/>
      2. ہفتہ وار فہرست: بھیجنے والے اور وصول کنندہ کی ایک فہرست ہر ہفتے صارفین کے جمع شدہ پوائنٹس کی بنیاد پر تیار کی جاتی ہے۔
      <br/><br/>
      3. درجہ بندی کے انعامات: ہر ہفتے کے اختتام پر، ہر فہرست کے ٹاپ تین کو انعامات دیے جاتے ہیں۔
      <br/><br/>
      4. حاصل کردہ تمغے: وہ صارفین جو پانچ مسلسل ہفتوں تک ایک ہی درجہ بندی حاصل کرتے ہیں، مستقل طور پر تمغہ حاصل کریں گے۔ اگر آپ رک جاتے ہیں، تو مسلسل حاصل کرنے کا وقت دوبارہ شمار کیا جائے گا۔
      <br/><br/>
      5. باضابطہ وضاحت کا حق: منتظم کو اس سرگرمی کی آخری وضاحت کا حق حاصل ہے۔ اگر آپ کے کوئی سوالات ہوں، تو براہ کرم ہماری کسٹمر سروس سے رابطہ کریں، وہ آپ کے سوالات کے جوابات دیں گے۔
      `
  }
}



// WEBPACK FOOTER //
// src/pages/app/ruby-monopoly-main/lang.js